import {memo} from 'react';
import GoogleLogin from 'react-google-login';
import getSocialLoginWpUser from '../../../actions/getsSocialLoginWpUser';
import {useDispatch} from 'react-redux';

const SmileGoogleLogin = memo(({text}) => {
    const dispatch = useDispatch();

    const responseGoogle = (response) => {
        dispatch( getSocialLoginWpUser( response ) )
    }

    return (
        <GoogleLogin
            clientId="630016222592-945eicc0d5im0plcfbpt8b3hfo376576.apps.googleusercontent.com"
            render={renderProps => (
                <button onClick={renderProps.onClick} className='cursor button Google' disabled={renderProps.disabled}>{text}</button>
            )}
            buttonText="Login"
            onSuccess={responseGoogle}
            onFailure={responseGoogle}
            cookiePolicy={'single_host_origin'}
        />
    );
});

export default SmileGoogleLogin;